import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss', './error-modal.component.rtl.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ErrorModalComponent implements OnInit {
  @Output() cancelErrorModal = new EventEmitter();
  @Output() cancelModal = new EventEmitter();
  @Input() errorMSg
  constructor() {
    console.log('test');
   }

  ngOnInit(): void {
    console.log('test'); 
  }
  closeModal(){
    this.cancelModal.emit(null)
      }
  onClickRefresh() {
    window.location.reload()
    this.cancelErrorModal.emit(null)
  }


}
